import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'


import NotarDash from './notar/NotarDash';
import UserDash from './user/UserDash';


/**
 * Renders the appropriate dashboard component based on the user type and signalr connection status.
 *
 * @return {JSX.Element} The rendered dashboard component.
 */

const ClientSwitch = () => {
    const signalrconnected = useSelector((state: any) => state.user.connected)
    const usertype = useSelector((state: any) => state.user.usertype)
    
    
    useEffect(() => {
       if (signalrconnected  !== undefined) {
          window.addEventListener('beforeunload', alertUser)
        }

        return () => {
          window.removeEventListener('beforeunload', alertUser)
        }
    }, [signalrconnected]);

  const alertUser = (event:any) => {
      event.preventDefault()
      event.returnValue = ''
  }

    return (
        <>
  
          {usertype === "notar" && signalrconnected &&
            <NotarDash />
          }
          {usertype === "user" && signalrconnected &&
            <UserDash />
          }
    </> 
    )

}

export default ClientSwitch;
